<template>
  <div class="introduce">
    <p align="center">
      <img class="introduce_img" src="../images/jiceintroduce.jpg" />
    </p>
  </div>
</template>

<script>
export default {
  name: "14introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
